// extracted by mini-css-extract-plugin
module.exports = {"title":"title","title__text":"title__text"};